import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Banner from "../components/banner"
import Section from "../components/section"
import TabContainer from "../components/tab-container"
import Empty from "../components/empty"

import bannerPng from "../images/news/banner.png"

const tabList = ["市场合作", "行业资讯", "新产品上线"]

const Page = () => (
  <Layout>
    <SEO title="新闻中心" />
    <Banner image={bannerPng} />
    <Section>
      <TabContainer
        tabList={tabList}
        style={{ paddingTop: 30 }}
      >
        <Empty />
        <Empty />
        <Empty />
      </TabContainer>
    </Section>
  </Layout>
)

export default Page
